import axios from "../../utils/axios";

 export const getUpdateBlog = async ({id, likes, isSaved}) =>{
    const responce = await axios.patch(`/blogs/${id}`,{
        likes,
        isSaved,
    });
    return responce.data;
 }